import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import { login, register } from '../services/api';

function LoginPage({ onLogin }) {
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (username, password) => {
    setLoading(true);
    setError('');
    setSuccessMessage('');
    try {
      const response = await login(username, password);
      
      // Login successful - set token and navigate
      onLogin(response.token);
      
      if (response.is_admin) {
        // Admin users go to admin dashboard
        navigate('/admin');
      } else if (response.needsApproval) {
        // Non-approved users go to profile page with a message
        setSuccessMessage(response.message || 'Login successful. Complete your profile for approval.');
        navigate('/profile');
      } else {
        // Approved users go to lookup page
        navigate('/lookup');
      }
    } catch (err) {
      if (err.response?.data?.needsApproval) {
        setError('Account pending approval. Please contact an administrator.');
      } else {
        setError('Invalid credentials');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (username, password, confirmPassword, email) => {
    setLoading(true);
    setError('');
    setSuccessMessage('');
    try {
      const response = await register(username, password, confirmPassword, email);
      setSuccessMessage(response.message);
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Registration failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <div style={{ textAlign: 'center', margin: '20px' }}>Processing...</div>}
      <LoginForm 
        onLogin={handleLogin} 
        onRegister={handleRegister}
        error={error} 
        successMessage={successMessage}
      />
    </div>
  );
}

export default LoginPage; 